import { useState } from 'react';
import {
  Box,
  Text,
  Input,
  Select,
  Flex,
  Button,
  NumberInput,
  NumberInputField,
  useToast,
  Heading
} from '@chakra-ui/react';
import axios from 'axios';
import { areas, states, districts } from '../../data';
import './index.css';
import { LoaderState } from '../LoaderState';

export const ContactForm = () => {
  const toast = useToast();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [nameValue, setNameValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [tagValue, setTagValue] = useState('');
  const [stateValue, setStateValue] = useState('');
  const [districtsValue, setDistrictsValue] = useState([]);
  const [cityValue, setCityValue] = useState('');
  const [consumption, setConsumption] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchDistricts = (e) => {
    const stateId = String(e);
    setDistrictsValue(districts[stateId]);
  };

  const saveContact = async (e) => {
    e.preventDefault();
    const data = {
      name: nameValue,
      phone: phoneValue,
      tag: tagValue,
      state: stateValue,
      city: cityValue,
      consumption: consumption,
      userId: user._id
    };

    try {
      setLoading(true);
      const res = await axios.post('https://bulk-messaging-server.herokuapp.com/contacts', data);
      setNameValue('');
      setPhoneValue('');
      setTagValue('');
      setStateValue('');
      setCityValue('');
      setConsumption('');
      if (res.data === 'Contact already exist') {
        toast({
          position: 'bottom',
          title: 'Contact already saved',
          description: 'The contact you are trying to save already exist in db',
          status: 'info',
          duration: 5000,
          isClosable: true
        });
      } else {
        toast({
          position: 'bottom',
          title: 'Contact saved.',
          description: 'You saved the contact.',
          status: 'success',
          duration: 3000,
          isClosable: true
        });
      }
      setLoading(false);
    } catch (error) {
      toast({
        position: 'bottom',
        title: 'Oops! Some error.',
        description: 'Bad Request Please try again',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
      console.log(error);
    }
  };

  return (
    <>
      {loading ? (
        <Flex pos="absolute" alignItems="center" justifyContent="center">
          <LoaderState />
        </Flex>
      ) : (
        <></>
      )}
      <form onSubmit={saveContact}>
        <Flex flexDir="column" alignItems="center" maxW="full" m={5}>
          <Heading size="xl">Save contact</Heading>
          <Input
            type="text"
            name="name"
            id="name"
            variant="filled"
            placeholder="Name*"
            required
            w="full"
            mt={10}
            mb={4}
            size="lg"
            onChange={(e) => setNameValue(e.target.value)}
            value={nameValue}
          />
          <NumberInput value={phoneValue} variant="filled" w="full" my={4} size="lg">
            <NumberInputField
              name="phone"
              id="phone"
              required
              placeholder="Mobile Number*"
              minLength="10"
              maxLength="10"
              onChange={(e) => setPhoneValue(e.target.value)}
              value={phoneValue}
            />
          </NumberInput>
          <Select
            placeholder="Area*"
            w="full"
            size="lg"
            my={4}
            required
            variant="filled"
            onChange={(e) => setTagValue(e.target.value)}
            value={tagValue}>
            {areas.areas.map((tag, index) => (
              <option key={index} value={tag}>
                {tag}
              </option>
            ))}
          </Select>
          <Flex w="full">
            <Select
              placeholder="State*"
              size="lg"
              my={4}
              required
              mr={2}
              variant="filled"
              onChange={(e) => {
                setStateValue(e.target.value);
                fetchDistricts(e.target.value);
              }}
              value={stateValue}>
              {states.states.map((state, index) => (
                <option key={index} value={state.stateId}>
                  {state.stateName}
                </option>
              ))}
            </Select>
            <Select
              placeholder="City*"
              onChange={(e) => setCityValue(e.target.value)}
              value={cityValue}
              size="lg"
              required
              my={4}
              variant="filled">
              {districtsValue.map((district, index) => (
                <option key={index} value={district.districtId}>
                  {district.districtName}
                </option>
              ))}
            </Select>
          </Flex>
          <Box w="full" my={4}>
            <Text>Per Month Diesel Consumption</Text>
            <NumberInput value={consumption} variant="filled" w="full" my={4} size="lg">
              <NumberInputField
                name="phone"
                id="phone"
                required
                placeholder="Diesel consumption"
                minLength="1"
                maxLength="5"
                onChange={(e) => setConsumption(e.target.value)}
                value={consumption}
              />
            </NumberInput>
          </Box>
          <Button type="submit" colorScheme="telegram" variant="solid" my={4}>
            Submit
          </Button>
        </Flex>
      </form>
    </>
  );
};
